import { Input } from "./ui/input";
import { Checkbox } from "./ui/checkbox";
import { CountryPicker, dialOf } from "./CountryPicker";

const EMAIL_RE = /^[^@\s]+@[^@\s]+\.[^@\s]+$/;
const PHONE_RE = /^[\d\s-]{4,20}$/;

export const emptyDetails = () => ({ name: "", email: "", region: "MY", number: "", consent: false, updates: false, touched: {} });

export const detailErrors = (v) => ({
  name: v.name.trim() ? "" : "Please enter your full name.",
  email: EMAIL_RE.test(v.email.trim()) ? "" : "Please enter a valid email address.",
  number: !v.number.trim() || PHONE_RE.test(v.number.trim()) ? "" : "Use digits, spaces or dashes only.",
  consent: v.consent ? "" : "Please agree to the privacy note to continue.",
});

export const detailsValid = (v) => Object.values(detailErrors(v)).every((e) => !e);

export const phoneOf = (v) => (v.number.trim() ? `+${dialOf(v.region)} ${v.number.trim()}` : null);

const Err = ({ msg, show, id }) => (show && msg ? <p className="mt-1 text-xs text-[var(--orange)]" data-testid={id}>{msg}</p> : null);

export const DetailsForm = ({ v, setV }) => {
  const e = detailErrors(v);
  const set = (k, val) => setV({ ...v, [k]: val });
  const touch = (k) => () => setV((p) => ({ ...p, touched: { ...p.touched, [k]: true } }));
  const t = v.touched;
  return (
    <div className="panel space-y-4 p-6 sm:p-8" data-testid="details-form">
      <div><p className="kicker">Your details</p><p className="mt-1 text-sm muted">So we can keep your result on record. Your share link and any team dashboard never show these.</p></div>
      <div className="grid gap-4 md:grid-cols-2">
        <div>
          <label className="text-sm font-medium">Full name *</label>
          <Input className="mt-1 h-11" value={v.name} onChange={(x) => set("name", x.target.value)} onBlur={touch("name")} data-testid="details-name" />
          <Err msg={e.name} show={t.name} id="details-name-error" />
        </div>
        <div>
          <label className="text-sm font-medium">Email *</label>
          <Input type="email" className="mt-1 h-11" value={v.email} onChange={(x) => set("email", x.target.value)} onBlur={touch("email")} data-testid="details-email" />
          <Err msg={e.email} show={t.email} id="details-email-error" />
        </div>
      </div>
      <div>
        <label className="text-sm font-medium">Phone number <span className="muted">(optional)</span></label>
        <div className="mt-1 flex gap-2">
          <CountryPicker value={v.region} onChange={(r) => set("region", r)} />
          <Input className="h-11" inputMode="tel" placeholder="12 345 6789" value={v.number} onChange={(x) => set("number", x.target.value)} onBlur={touch("number")} data-testid="details-phone" />
        </div>
        <Err msg={e.number} show={t.number} id="details-phone-error" />
      </div>
      <label className="flex items-start gap-3 text-sm">
        <Checkbox checked={v.consent} onCheckedChange={(c) => setV({ ...v, consent: c === true, touched: { ...v.touched, consent: true } })} className="mt-0.5" data-testid="details-consent" />
        <span>I agree my details and answers are stored to produce my result, as described in the privacy note. *</span>
      </label>
      <Err msg={e.consent} show={t.consent} id="details-consent-error" />
      <label className="flex items-start gap-3 text-sm">
        <Checkbox checked={v.updates} onCheckedChange={(c) => set("updates", c === true)} className="mt-0.5" data-testid="details-updates" />
        <span>Send me occasional updates from mpwrd.work and VentureBaseline.</span>
      </label>
      <p className="rounded-lg bg-[#F4F4F0] p-3 text-xs muted" data-testid="privacy-note"><b>Privacy note.</b> Your name, email and phone are visible only to the mpwrd.work admin. They're used to keep your result on record and, if you opt in, to send updates. Result links and team dashboards stay anonymous.</p>
    </div>
  );
};
